<template>
  <div>
    <div class="modal-header d-lg-flex justify-content-between w-100">
      <h3>Nuevo Prospecto</h3>
    </div>
    <div class="mt-n3 modal-body pb-0">
      <form @submit.prevent="create">
        <div class="form-group row mb-0">
          <div class="col-lg-5">
            <label class="form-control-label m-0">Nombre de la empresa *</label>
          </div>
          <div class="col-lg-7"> 
              <base-input 
                type="text" 
                v-model="company"
                placeholder="Nombre de la empresa"
                inputClasses="input-group-alternative"
                class="m-0"
                required>
              </base-input>
          </div>
        </div>
        <hr class="my-3">
        <div class="form-group row mb-0">
          <div class="col-lg-5">
            <label class="form-control-label m-0">Nombre *</label>
          </div>
          <div class="col-lg-7"> 
              <base-input 
                type="text" 
                v-model="name"
                placeholder="Nombre"
                inputClasses="input-group-alternative"
                class="m-0"
                required>
              </base-input>
          </div>
        </div>
        <hr class="my-3">
        <div class="form-group row mb-0">
          <div class="col-lg-5">
            <label class="form-control-label">Teléfono *</label>
          </div>
          <div class="col-lg-7"> 
              <base-input 
                type="number" 
                v-model="phone"
                placeholder="Número de teléfono"
                inputClasses="input-group-alternative"
                class="m-0"
                required>
              </base-input>
          </div>
        </div>
        <hr class="my-3">
        <div class="form-group row mb-0">
          <div class="col-lg-5">
            <label class="form-control-label">Estado *</label>
          </div>
          <div class="col-lg-7"> 
              <multiselect 
                v-model="selState" 
                placeholder="Estado" 
                :options="states"
                label="name"
                track-by="code"
                :show-labels="false"
              />
          </div>
        </div>
        <hr class="my-3">
        <div class="form-group row mb-0">
          <div class="col-lg-5">
            <label class="form-control-label">Ciudad *</label>
          </div>
          <div class="col-lg-7"> 
              <base-input 
                type="text" 
                v-model="city"
                placeholder="Ciudad"
                inputClasses="input-group-alternative"
                class="m-0"
                required>
              </base-input>
          </div>
        </div>
        <hr class="my-3">
        <div class="form-group row mb-0">
          <div class="col-lg-5">
            <label class="form-control-label">Correo electrónico *</label>
          </div>
          <div class="col-lg-7"> 
              <base-input 
                type="email" 
                v-model="email"
                placeholder="Correo electrónico"
                inputClasses="input-group-alternative"
                class="m-0"
                required>
              </base-input>
          </div>
        </div>
        <hr class="my-3">
        <div class="form-group row mb-0">
          <div class="col-lg-5">
            <label class="form-control-label">Ramo *</label>
          </div>
          <div class="col-lg-7"> 
            <multiselect 
              v-model="sector" 
              placeholder="Ramo" 
              :options="sectors"
              :show-labels="false"
            />
        </div>
        </div>
        <hr class="my-3">
        <div class="text-right mb-4">
          <base-button 
            nativeType="submit" 
            icon="fa fa-check"
            :disabled="!valid"
          >
            Registrar
          </base-button>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import states from '@/data/states.json'
import { addDoc, getFirestore, collection, serverTimestamp } from "firebase/firestore";

  export default {
    components: {
      Multiselect
    },
    data() {
      return {
        company: null,
        name: null,
        phone: null,
        selState: null,
        city: null,
        email:null,
        sector: null,
        states: states,
        sectors: [
          "Distribuidor",
          "Fabricante",
          "No identificado"
        ]
      }
    },
    methods: {
      create() {
        if(this.valid){
          const json = {
            company: this.company,
            name: this.name,
            phone: this.phone,
            state: this.selState.code,
            city: this.city,
            email:this.email,
            sector: this.sector,
            assigned: null,
            datetime: serverTimestamp()
          }
  
          // console.log('JSON', json);
          const db = getFirestore();
          const coll = collection(db, "prospects");
          addDoc(coll, json)
            .then(() => {
              this.$swal("Éxito", "Prospecto registrado correctamente", "success");
              this.$emit("success");
              this.$emit("close");
            })
            .catch((error) => {
              console.error("Error", error)
              this.$swal("Error", error.message, "error");
            });
        }
      }
    },
    computed:{
      valid() {
        return (
          this.company &&
          this.name &&
          this.phone &&
          this.selState &&
          this.city &&
          this.email &&
          this.sector
        )
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>